module.exports = __webpack_public_path__ + "static/img/bg1.2027ade.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/6/bg1.png
// module id = GHoN
// module chunks = 0